import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VTextField,{attrs:{"prepend-icon":"email","disabled":_vm.disabled,"rules":[v => /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(v) || 'keine gültige E-Mailadresse' ],"error-messages":_vm.errors,"value":_vm.value,"label":"E-Mailadresse"},on:{"change":_vm.checkMailAvailability,"input":val => _vm.$emit('input', val)}})
}
var staticRenderFns = []

export { render, staticRenderFns }